import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AcpsharedService } from './acpshared.service';

@Injectable()
export class AcpService {

	selectedFile: File = null;
	fd = new FormData();

	constructor(private http: HttpClient, private acpsharedService: AcpsharedService) { }
	servLoginData: any;

	Login(usrName: string, usrPwd: string, projectIdentifier: string, captcha : string): Observable<any> {
		return this.http.post(environment.appUrl + "acp/login", { usrName: usrName, usrPwd: usrPwd, projectIdentifier: projectIdentifier,captcha:captcha })
			.map(result => {
				if (result.hasOwnProperty("token")){
					localStorage.setItem('acp_auth_token', result['token']);
				}
				return this.servLoginData = result;

			});
	}

	saveAdminUser(postData, PID, uId, projectIdentifier) {
		return this.http.post(environment.appUrl + "acp/userMgmt", { data: postData, PID: PID, uId: uId, projectIdentifier: projectIdentifier })
			.map(result => {
				return result;
			});
	}

	saveGstData(postData, PID,  projectIdentifier) {
		return this.http.post(environment.appUrl + "acp/gst", { data: postData, PID: PID, projectIdentifier: projectIdentifier })
			.map(result => {
				return result;
			});
	}


	getGstdata(PID, projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/gst", { params: { PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});
	}



	getGstEdit(userID: any, PID, projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/gsteditstate", { params: { userID:  "6281fd0258b08938d0b7344f", PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});

	}

	savePaymentSettings(postData, PID,  projectIdentifier) {
		return this.http.post(environment.appUrl + "acp/savepaymentsettings", { data: postData, PID: PID, projectIdentifier: projectIdentifier })
			.map(result => {
				return result;
			});
	}



	getPaymentDetails(PID,projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/getpaymentsettings", { params: { PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});
	}
	
	getDelcartionData(PID,projectIdentifier):Observable<any> {
		return this.http.get(environment.appUrl + "acp/getdeclartionsetting", { params: { PID: PID,projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});
	}

	saveDelcartionData(postData, PID,  projectIdentifier) {
		return this.http.post(environment.appUrl + "acp/savedeclartionsetting", { data: postData, PID: PID, projectIdentifier: projectIdentifier })
			.map(result => {
				return result;
			});
	}

   getApplnStateData(PID):Observable<any>{
	//console.log(formJson.components);
	return this.http.get(environment.appUrl + "application/gststate",{params:{projectID:PID}})
	  .map(result => {
		return result;
	});
}


	getAdminUser(PID, projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/userMgmt", { params: { PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});
	}

	getUsers(userID: any, PID, projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/user", { params: { userID: userID, PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});

	}


	isLoggedIn(projectId: string): Observable<any> {
		return this.http.post(environment.appUrl + "acp/usrLogCheck", { projectId: projectId })
			.map(result => {
				console.log('check logged In here');
				this.servLoginData = result;
				if (this.servLoginData["message"] == "success" && this.servLoginData["success"]) {
					this.acpsharedService.ACPProjectIdentifier.next(projectId);
					this.acpsharedService.IsACPUserLoggedIn.next(true);
					this.acpsharedService.ACPLoggedUserName.next(this.servLoginData['data']['userName']);
					this.acpsharedService.ACPLoggedUserType.next(this.servLoginData['data']['userType']);
					this.acpsharedService.hasAcpAuthToken.next(true);
				}else {
					this.acpsharedService.IsACPUserLoggedIn.next(false);
					this.acpsharedService.hasAcpAuthToken.next(false);
				}
				return this.servLoginData;
			});
	}

	logout(projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/logout", { params: { projectIdentifier: projectIdentifier } }).map(result => {
			//console.log('here');
			// localStorage.setItem('usrToken', '');
			localStorage.removeItem('acp_auth_token');
			this.acpsharedService.IsACPUserLoggedIn.next(false);
			this.acpsharedService.hasAcpAuthToken.next(false);
			return this.servLoginData = result['success'];
		});
	}

	saveDocMgmt(fddata,projectIdentifier) {
		var headers = new HttpHeaders();
		headers.append('Content-Type', 'application/form-data');
			console.log(fddata);
		return this.http.post(environment.appUrl + "acp/saveDocMgmt?projectIdentifier="+projectIdentifier, fddata)
		.map(result => {
			return result;
		});
	}
	/* saveDocMgmt(doccategory,docname,PID, projectIdentifier,FileSelPath) {

		return this.http.post(environment.appUrl + "acp/saveDocMgmt", {doccategory:doccategory,docname:docname,projectId:PID,projectIdentifier:projectIdentifier,FilePath:FileSelPath})
			.map(result => {
				return result;
			});
		/* return this.http.post(environment.appUrl + "acp/saveDocMgmt",{fddata,doccategory:doccategory,projectId:PID,projectIdentifier:projectIdentifier}, {headers: headers })
		.map(result => {

		});  *//*
	} */

	getDocList(PID, projectIdentifier) {
		return this.http.get(environment.appUrl + "acp/docMgmt", { params: { PID: PID, projectIdentifier: projectIdentifier } })
			.map(result => {
				return result;
			});
	}

	getLatestSearch(PID, projectIdentifier, searchtype, searchval) {
		return this.http.post(environment.appUrl + "acp/lSearch", { PID: PID, projectIdentifier: projectIdentifier, searchtype, searchval })
			.map(result => {
				return result;
			});
	}
	getTransactionDetails(PID, projectIdentifier, regno) {
		return this.http.post(environment.appUrl + "acp/TransactDetailService", { PID: PID, projectIdentifier: projectIdentifier, regnovalue: regno})
			.map(result => {
				return result;
			});
	}
	getunblkaccessServices(PID, projectIdentifier, unblkaccesstype, unblkaccessval) {
		return this.http.post(environment.appUrl + "acp/GetunblkaccessRoute", { PID: PID, projectIdentifier: projectIdentifier, unblkaccesstype, unblkaccessval })
			.map(result => {
				return result;
			});
	}
	getLatestReports(PID, projectIdentifier) {
		return this.http.post(environment.appUrl + "acp/GetReports", { PID: PID, projectIdentifier: projectIdentifier })
			.map(result => {
				return result;
			});
	}
	getRegDetails(PID, projectIdentifier, appRegId) {
		return this.http.post(environment.appUrl + "acp/getRegDetails", { PID: PID, projectIdentifier: projectIdentifier, appRegId: appRegId })
			.map(result => {
				return result;
			});
	}

	getAppln(accID, projID):Observable<any> {
		return this.http.get(environment.appUrl + "acp/getAppln", { params: { accountID: accID, projectID: projID } })
			.map(result => {
				return result;
			});
	}
  photoSignRuleSubmit(formVal,formJson):Observable<any>{
				return this.http.post(environment.appUrl + "application/savephotosignvalidrule",{formVal: formVal,formJson:formJson.components})
		  .map(result => {
		    return result;
	    });
  }
	saveAppSetting(fdData,projectIdentifier,appStorageService) {
		var headers = new HttpHeaders();
		headers.append('Content-Type', 'application/form-data');
		return this.http.post(environment.appUrl + "acp/projectSetting?projectIdentifier="+projectIdentifier+"&appStorageService="+appStorageService,fdData)
			.map(result => {
				return result;
			});
	}
	/* saveAppSetting_FileUpload(postData, logoPathValue, PID, projectIdentifier,logoUp,appStartCheck) {
		return this.http.post(environment.appUrl + "acp/projectSetting_FileUpload", { data: postData,logoPath:logoPathValue, projId: PID, projectIdentifier: projectIdentifier ,logoUp:logoUp,appStartCheck:appStartCheck})
			.map(result => {
				return result;
			});
	} */
	AcpRightsIns(PID, projectIdentifier, dataDets: any, roleIDDet: any) {
		return this.http.post(environment.appUrl + "acp/acp_rightssave", { PID: PID, projectIdentifier: projectIdentifier, dataDets: dataDets, roleIDDet: roleIDDet })
			.map(result => {
				return result;
			});
	}
	AcpGetRole(PID, projectIdentifier, roleID: any) {
		return this.http.post(environment.appUrl + "acp/acp_getRole", { PID: PID, projectIdentifier: projectIdentifier, roleID: roleID })
			.map(result => {
				return result;
			});
	}
	getRolesNew(PID, projectIdentifier) {
		var RoleIdVal = this.servLoginData.data.userType;
		return this.http.post(environment.appUrl + "acp/acp_getRoleAccess", { PID: PID, projectIdentifier: projectIdentifier, roleID: RoleIdVal })
			.map(result => {
				return result;
			}).toPromise();
	}
	getRolesNewNav(PID, projectIdentifier,RoleIdVal:any) {
		return this.http.post(environment.appUrl + "acp/acp_getRoleAccess", { PID: PID, projectIdentifier: projectIdentifier, roleID: RoleIdVal })
			.map(result => {
				return result;
			}).toPromise();
	}
	// Email Setting
	getNotificationBy(reqData: any): Observable<any> {
		return this.http.post(environment.appUrl + "acp/getNotificationById", reqData);
	}
	addEditEmailTemplate(reqData: any): Observable<any> {
		return this.http.post(environment.appUrl + "acp/addEditEmail", reqData);
	}
	deleteUsers(userID: any){
		return this.http.delete(environment.appUrl + "acp",{params:{userID: userID}})
		.map(result => {
			return result;
		});

   }
   saveReconcile(fddata) {
	var headers = new HttpHeaders();
	headers.append('Content-Type', 'application/form-data');

	return this.http.post(environment.appUrl + "acp/saveReconcile", fddata)
		.map(result => {
			return result;
		});
  }
  processReconcile(PID, projectIdentifier){
	return this.http.post(environment.paymentGatewayUrl + "reconcile_process.php", { projectId: PID})
		.map(result => {
			return result;
		});
  }
  getReconcileReport(PID, projectIdentifier,postData){
	return this.http.post(environment.appUrl + "acp/getReconcileReport", { projectId: PID,projectIdentifier:projectIdentifier,data: postData})
		.map(result => {
			return result;
		});
  }

  recdownloadData(projectIdentifier,logId,type,payType,bankType) {
	return this.http.get(environment.appUrl + "acp/recdownloadData",{params:{projectIdentifier:projectIdentifier,logId:logId,type:type,payType:payType,bankType:bankType}})
	  .map(result => {
		return result;
	});
  }
  sendMailIfValidUser(PID, projectIdentifier,formJSON:any)
   {
	   let formJSON1 = JSON.stringify(formJSON);
	   return this.http.post(environment.appUrl + "acp/forgot", { projectId: PID,projectIdentifier:projectIdentifier,formJSON: formJSON1})
		.map(result => {
			return result;
		});
   }
  passwordReset(PID, projectIdentifier,formJSON:any)
   {
		let formJSON1 = JSON.stringify(formJSON);
		return this.http.post(environment.appUrl + "acp/forgotreset", {projectId: PID,projectIdentifier:projectIdentifier, formJSON: formJSON1})
		.map(result => {
			return result;
		});
   }
   getTransactionDet(PID, projectIdentifier, appRegId,onlineRefId,regNo){
		return this.http.post(environment.appUrl + "acp/getTransactionDet", { PID: PID, projectIdentifier: projectIdentifier, appRegId: appRegId,onlineRefId:onlineRefId,registration_no:regNo })
		.map(result => {
			return result;
		});
   }
}
